import { render, staticRenderFns } from "./NavShow.vue?vue&type=template&id=0d6063c8&scoped=true&"
import script from "./NavShow.vue?vue&type=script&lang=js&"
export * from "./NavShow.vue?vue&type=script&lang=js&"
import style0 from "./NavShow.vue?vue&type=style&index=0&id=0d6063c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6063c8",
  null
  
)

export default component.exports